import { ActionTypes } from "./types";

const {
    ADD_SGC_CONFIGURATION_MODE,
    EDIT_SGC_CONFIGURATION_MODE,
    DELETE_SGC_CONFIGURATION_MODE,
    OPEN_SGC_CONFIGURATION_SNACK,
    CLOSE_SGC_CONFIGURATION_SNACK,
    CREATE_SGC_CONFIGURATION,
    MOD_SGC_CONFIGURATION,
    DELETE_SGC_CONFIGURATION,
    CLEAR_SGC_CONFIGURATIONS,
    GET_SGC_CONFIGURATIONS,
    SET_SGC_CONFIGURATIONS_FILTERS,
    SGC_CONFIGURATION_SELECTED,
    RESET_SGC_CONFIGURATION_SELECTED,
    
    SET_CONFIG_PAGE_SGC_CONFIGURATIONS,
    SET_CONFIG_PAGE_SIZE_SGC_CONFIGURATIONS,
    SET_CONFIG_FILTER_SGC_CONFIGURATIONS,
    SET_CONFIG_SORTED_SGC_CONFIGURATIONS
} = ActionTypes

const INITIAL_STATE = {
    addMode: false,
    deleteMode: false,
    sgcConfigurations: [],
    station: null,
    sgcConfigurationSelected: {},
    snackBar: { 
        msg: "", 
        isOpen: false 
    },
    config: {
        page: 0,
        pageSize: 20,
        filtered: [],
        sorted: []
    },
}

export const sgcConfigurationsReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case ADD_SGC_CONFIGURATION_MODE:
            return {
                ...state,
                addMode: true,
                deleteMode: false
            }

        case EDIT_SGC_CONFIGURATION_MODE:
            return {
                ...state,
                addMode: false,
                deleteMode: false
            }

        case OPEN_SGC_CONFIGURATION_SNACK:
            return {
                ...state,
                snackBar: { 
                    msg: payload, 
                    isOpen: true 
                }
            }

        case CLOSE_SGC_CONFIGURATION_SNACK:
            return {
                ...state,
                snackBar: { 
                    msg: '', 
                    isOpen: false 
                }
            }

        case DELETE_SGC_CONFIGURATION_MODE:
            return {
                ...state,
                addMode: false,
                deleteMode: true
            }

        case SGC_CONFIGURATION_SELECTED:
            let index = state.sgcConfigurations.findIndex(item => item.id === payload)
            if (index === -1) return state;
            else return {
                ...state,
                sgcConfigurationSelected: state.sgcConfigurations[index]
            }

        case RESET_SGC_CONFIGURATION_SELECTED:
            return {
                ...state,
                sgcConfigurationSelected: {},
                addMode: false,
                deleteMode: false,
            }

        case CLEAR_SGC_CONFIGURATIONS:
            return {
                ...state,
                ...INITIAL_STATE,
            };

        case SET_SGC_CONFIGURATIONS_FILTERS:
            let sgcConfigurations = state.sgcConfigurations
            if(payload.key === 'station') sgcConfigurations = []
            return {
                ...state,
                [payload.key]: payload.data,
                sgcConfigurations
            };

        case GET_SGC_CONFIGURATIONS:
            return {
                ...state,
                sgcConfigurations: payload
            }

        case CREATE_SGC_CONFIGURATION:
            return {
                ...state,
                sgcConfigurations: [payload, ...state.sgcConfigurations]
            }

        case MOD_SGC_CONFIGURATION:
            index = state.sgcConfigurations.findIndex(item => item.id === payload.id)
            if (index === -1) return state;
            let editedCondition = state.sgcConfigurations
            editedCondition[index] = {
                ...editedCondition[index],
                ...payload
            }
            return {
                ...state,
                sgcConfigurationSelected: editedCondition[index],
                sgcConfigurations: editedCondition
            }

        case DELETE_SGC_CONFIGURATION:
            return {
                ...state,
                sgcConfigurations: state.sgcConfigurations.filter(condition => condition.id !== payload)
            }

        case SET_CONFIG_FILTER_SGC_CONFIGURATIONS:
            return {
                ...state,
                config: {
                    ...state.config,
                    filtered: payload,
                    page: 0,
                },
            };

        case SET_CONFIG_PAGE_SGC_CONFIGURATIONS:
            return {
                ...state,
                config: {
                    ...state.config,
                    page: payload,
                },
            };

        case SET_CONFIG_PAGE_SIZE_SGC_CONFIGURATIONS:
            return {
                ...state,
                config: {
                    ...state.config,
                    pageSize: payload,
                    page: 0,
                },
            };

        case SET_CONFIG_SORTED_SGC_CONFIGURATIONS:
            return {
                ...state,
                config: {
                    ...state.config,
                    sorted: payload,
                    page: 0,
                }
            };

        default:
            return state;
    }
}